module.exports = __webpack_public_path__ + "img/giuseppe_cramarossa.5f7fc538.jpg";